module.exports = __webpack_public_path__ + "img/DeliveryUnconditional.534577d2.png";